// extracted by mini-css-extract-plugin
export default {"base":"Content_base__ICczy","isEditor":"Content_isEditor__z9IMd","image-style-side":"Content_image-style-side__eWAiu"};